<template>
  <div @keyup.enter="login(inputs)">
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >
            <v-card class="elevation-12">
              <v-toolbar
                dark
                color="primary"
              >
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="inputs.username"
                    prepend-icon="person"
                    autocomplete="disabled"
                    :label="username"
                    type="text"
                  />
                  <v-text-field
                    v-model="inputs.password"
                    prepend-icon="lock"
                    :label="password"
                    type="password"
                  />
                  <v-card-actions>
                    <!-- <v-btn color="primary" @click="passwordReset">
                      {{$t("message.password_reset")}}
                    </v-btn> -->
                    <v-spacer />
                    <v-btn
                      color="primary"
                      @click="login(inputs)"
                    >
                      {{
                        $t("message.login")
                      }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      inputs: {
        username: "",
        password: ""
      }
    };
  },
  computed: {
    username() {
      return this.$t("message.username");
    },
    password() {
      return this.$t("message.password");
    }
  },
  methods: {
    ...mapActions("auth", ["loginAction", "testAction"]),

    login({ username, password }) {
      let credentials = { username: username, password: password };
      this.loginAction(credentials).then(() =>
        this.$router.push("/admin/dashboard/charts")
      );
    },
    passwordReset() {
      this.$router.push("/password/reset/");
    }
  }
};
</script>
